<template>
  <v-container id="player-select">
    <v-form ref="form" v-model="isValid" class="text-center">
      <draggable v-model="players" v-bind="dragOptions">
        <transition-group type="transition">
          <div class="player" v-for="(player, index) in players" :key="player.id" 
            @mousedown="startSortingTimeout"
            @touchstart="startSortingTimeout"
            @mouseup="stopSortingTimeout"
            @touchend="stopSortingTimeout"
            v-bind:class="{ 'wiggle-container': isSorting }"
          >
            <v-text-field
              v-model="player.name"
              :placeholder="'Player ' + (index + 1)"
              :rules="[rules.required]"
              solo
              :flat="!isSorting"
              @click:append="removePlayer(player)"
              :append-icon="isSorting ? null : 'mdi-close'"
              hide-details
              class="mb-4"
              :disabled="isSorting"
              @change="player.drinks = 0"
            ></v-text-field>
          </div>
        </transition-group>
      </draggable>
      <v-btn
        @click="addPlayer"
        color="#fff"
        width="100%"
        :disabled="isSorting"
      >Add player</v-btn>
    </v-form>
    <v-fab-transition>
      <v-btn
        color="#fff"
        light
        x-large
        fixed
        bottom
        right
        fab
        v-if="!isPlaying"
        v-show="!isSorting && !hasPlayTimeout"
        @click="start"
      >
        <v-icon class="gradient-text">mdi-dice-multiple</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        color="success"
        x-large
        fixed
        bottom
        right
        fab
        v-show="isSorting"
        @click="disableSorting"
      >
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-snackbar
      v-model="showIsInvalid"
      v-if="!isPlaying"
      :timeout="2000"
    >
      Invalid player names
      <v-btn
        color="purple"
        text
        @click="showIsInvalid = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'player-select',
  components: {
    draggable
  },
  props: {
    isPlaying: Boolean
  },
  data: () => ({
    players: [],
    isValid: false,
    isSorting: false,
    sortingTimeout: null,
    showIsInvalid: false,
    hasPlayTimeout: true,
    rules: {
      required: value => !!value || 'Player name is required.'
    }
  }),
  mounted () {
    if (localStorage.players) {
      this.players = JSON.parse(localStorage.players);
    } else {
      this.addPlayer();
      this.addPlayer();
    }

    if (!this.isPlaying) {
      setTimeout(() => {
        this.hasPlayTimeout = false;
      }, 500);
    }
  },
  watch: {
    players: {
      handler (newValue) { localStorage.players = JSON.stringify(newValue); },
      deep: true
    },
    isPlaying () {
      if (!this.isPlaying) {
        this.hasPlayTimeout = true;
        setTimeout(() => {
          this.hasPlayTimeout = false;
        }, 500);
      }
    }
  },
  computed: {
    canStart () {
      return !this.hasPlayTimeout && this.isValid && this.players.length > 1;
    },
    dragOptions () {
      return {
        animation: 200,
        disabled: !this.isSorting
      }
    }
  },
  methods: {
    addPlayer () {
      this.players.push({
        id: Math.random().toString(36).substr(2, 9),
        name: null,
        drinks: 0
      });
    },
    removePlayer (player) {
      this.players.splice(this.players.indexOf(player), 1);
    },
    startSortingTimeout () {
      if (!this.isSorting) {
        this.sortingTimeout = setTimeout(() => { 
          this.isSorting = true 
        }, 600);
      }
    },
    stopSortingTimeout () {
      clearTimeout(this.sortingTimeout);
    },
    disableSorting (e) {
      e.preventDefault();
      this.stopSortingTimeout;
      this.isSorting = false;
    },
    applyEasterEggs () {
      this.players.forEach(player => {
        if (player.name === 'b' || player.name === 'B') {
          player.name += 'oomer';
        }
      });
    },
    start () {
      this.$refs.form.validate();

      if (!this.canStart) {
        this.showIsInvalid = true;
        return;
      }

      this.applyEasterEggs();

      this.$emit('start', this.players);
    }
  }
};
</script>